export default __webpack_public_path__ + "static/media/project-winter.41eb5727.png";